import React from 'react';

import { createRoot } from 'react-dom/client';
import { NavLink, Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { NavLinkContext, UpcomingFeaturesHandler } from '@ergeon/core-components';

import HelpPage from 'components/HelpPage';
import HomePage from 'components/HomePage';
import LandingPage from 'components/LandingPage';
import Layout from 'components/Layout';
import NotFoundPage from 'components/NotFoundPage';
import store from 'flux/store';

import './tailwind.css';
import './index.scss';

import '@ergeon/core-components/dist/index.css';

import '@ergeon/help-components/dist/help-components.css';

const history = createBrowserHistory();

const App = (
  <Provider store={store}>
    <Router history={history}>
      <UpcomingFeaturesHandler>
        <NavLinkContext.Provider value={NavLink}>
          <Layout>
            <Switch>
              <Route component={HomePage} exact path="/" />
              <Route component={LandingPage} exact path="/help" />
              <Route component={HelpPage} exact path="/help/:nodeKey" />
              <Route component={HelpPage} exact path="/help/search" />
              <Route component={NotFoundPage} exact path="*" />
            </Switch>
          </Layout>
        </NavLinkContext.Provider>
      </UpcomingFeaturesHandler>
    </Router>
  </Provider>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(App);
